import React, { Component, Fragment } from 'react';
import ReactCustomFlagSelect from './ReactCustomFlagSelect';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import staticData from './static';
import { getYearMonth } from './helper';
import './App.css';
import closeIcon from "./img/close.jpg";
import plusIcon from "./img/plus1.png";
import minusIcon from "./img/minus1.png";
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import 'react-responsive-modal/styles.css';

export default class AccountForm extends Component {

    constructor(props){
        super(props);
        this.pickMulti = React.createRef();
        this.validateForm =this.validateForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getFreq = this.getFreq.bind(this);
        this.urlParams = new URLSearchParams(window.location.search);
        this.incrementMinMonthList = [5832, 5846];
        this.monthPickerLimitMin = this.getMonthPickerLimitMin();
        this.monthPickerLimitMax = {year: parseInt(moment().add(11, 'months').format('YYYY')), month: parseInt(moment().add(11, 'months').format('M'))};
        let validity = this.monthPickerLimitMin;
        this.activateSuiteForLot = [5741, 5751]; 
        this.minAllowedUsers = props.selectedPass?.pricing_data?.min_allowed_users || 1;
        let vehicleDetail = this.preSetVehicleDetail(this.minAllowedUsers);
        this.state = {
          subscriptionType: 'account',
          passesScreenActive: true,
          fields: {
            areaCode: 1,
            areaCode2: 1,
            email: '',
            info_filled_by: 'account',
            payment_by: 'account'
          },
          userEmail: [{email: ''}],
          vehicleDetail,
          errors: {},
          arenaId: this.urlParams.get('id'),
          setOpen: false,
          validity,
          no_of_spots: 1,
          no_of_vehicles: vehicleDetail?.length,
          visible: this.urlParams.get('visible')
        };
    } 

    getMonthPickerLimitMin = () => {
      let obj;
      if(this.props.parkingId === 6029){
        obj = getYearMonth({year: 2025, month: 7});
      }else{
        obj = getYearMonth()
      }
      return obj;
    }

     preSetVehicleDetail = (count) => {
        const arr = [];
        const vehicleDetail = { email: '', vehicle_type: '', vehicle_make: '', vehicle_model: '', country_code: '1', contact_number: '', alternate_vehicles: [] };
        for(let i=0; i<count; i++){
          arr.push({...vehicleDetail, ...{alternate_vehicles:[]}});
        }
        return arr;
     }
    
      handleAreaCode(areaCode){
        let fields = {...this.state.fields};
        fields['areaCode'] = areaCode;
        this.setState({ 
          fields 
        });
      }
    
      checkForUserEmails(){
        let isValid = true;
        let userEmailCount = this.state.userEmail.filter(item => item.email);
        if(this.state.fields['payment_by'] === 'individual'){
          if(userEmailCount.length != this.state.no_of_spots){
            isValid = false;
            this.props.toast.error('Missing user email');
          }
        }else if(userEmailCount && userEmailCount.length < this.state.no_of_spots){
          isValid = false;
          this.props.toast.error('Missing user email');
        }
        return isValid;
      }

    
      find(search, keys){
        if(!search) {
          return {
            "id": "1",
            "name": "US",
            "displayText": "United States (+1)",
            "country": "United States",
            "locale": "",
            "flag": `${URL.S3_BUCKET2}/FlagKit/US.imageset/US.png`
          }
        }
        var lowSearch = search.toLowerCase();
        return staticData.countryCode.filter(function(item){
            return keys.some( key => 
                String(item[key]).toLowerCase().includes(lowSearch) 
            );
        });
      }
    
      handleClose(){
        this.setState({booked: false, bookedID: null }, () => {
          this.manageBodyBackground(false);
        })
      }
    
      handleChange(e) {
        let fields = {...this.state.fields};
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        }, () => {
          if(e.target.name === 'payment_by' && e.target.value === 'individual'){
            let spotCount = this.state.no_of_spots;
            let userEmail = [...this.state.userEmail];
            if(spotCount < userEmail.length){
              let diff = userEmail.length - spotCount;
              userEmail.splice(userEmail.length - diff, diff);
              this.setState({
                userEmail
              })   
            }
          }else if(e.target.name === 'reserve_spot'){
            this.calculateAccountPrice();
          }
        });
      }
    
      handleAcceptTC(){
        this.setState({
          isAcceptTC: !this.state.isAcceptTC
        })
      }
    
      handleClickValidity = (e) => {
          this.pickMulti.current.show()
      }
    
      handleValidityChange = (year, month) => {
          this.setState({
            validity: {year, month}
          }, () => {
            this.pickMulti.current.dismiss();
          });
      }
    
      getFreq(){
          if(!this.state.fields["pass_type"]) return;
          this.state.passList.filter(item => item.pass_type === this.state.fields["pass_type"]).map(item => <option>{item.pric}</option>);
      }
    
      handleIncrement(){
        const arr = [...this.state.userEmail];
        arr.push({
          email: ''
        });
        
        this.setState({
          userEmail: arr
        })
      }
    
      handleDecrement(index){
          const arr = [...this.state.userEmail];
          arr.splice(index, 1);
          this.setState({
            userEmail: arr
          }, () => { 
            // console.log("===state===", this.state.discount)
          })
      }
    
      handleVehicleIncrement(){
        let count = this.state.no_of_vehicles + 1;
        const arr = [...this.state.vehicleDetail];
        arr.push({vehicle_no: '', vehicle_type: '', vehicle_make: '', vehicle_model: '', country_code: '1', contact_number: '', email: '', alternate_vehicles: [] });
        
        this.setState({
          no_of_vehicles: count,
          vehicleDetail: arr
        })
      }
    
      handleVehicleDecrement(index){
        if(this.state.no_of_vehicles > this.minAllowedUsers) {
          const arr = [...this.state.vehicleDetail];
          arr.splice(index, 1);
          this.setState({
            no_of_vehicles: this.state.no_of_vehicles - 1,
            vehicleDetail: arr
          }, () => { 
            // console.log("===state===", this.state.discount)
          })
        }  
      }
    
      handleVehicleChange(e, index){
        const arr = [...this.state.vehicleDetail];
        arr[index][e.target.name] = e.target.name === 'vehicle_no' && e.target.value ? e.target.value.toUpperCase() : e.target.value;
        this.setState({
          vehicleDetail: arr
        })
      }

      handleVehiclePluginChange(index, name, value){
        const arr = [...this.state.vehicleDetail];
        arr[index][name] = value;
        this.setState({
          vehicleDetail: arr
        })
      }

      handleAlternateVehicleChange(e, parentIndex, childIndex){
        const arr = [...this.state.vehicleDetail];
        arr[parentIndex]['alternate_vehicles'][childIndex][e.target.name] = e.target.value;
        this.setState({
          vehicleDetail: arr
        })  
      }

      getAlternateVehicleFields(parentIndex){
        return this.state.vehicleDetail[parentIndex]['alternate_vehicles'].map((item, childIndex) => {
          const isLicenseSpecialChar = item.vehicle_no && this.nonSpecialCharacterForValue(item.vehicle_no); 
          return (
            <div>
              <div className='vehicle-detail alternate-vehicle-detail'>Alternate Vehicle {childIndex + 1}</div>
              <div className="upper">
                  <span>License Plate</span>
                  <input
                    style={{textTransform: 'uppercase'}}
                    className="pay-fields" 
                    value={item.vehicle_no}
                    name="vehicle_no"
                    onChange={(e) => this.handleAlternateVehicleChange(e, parentIndex, childIndex)}
                    maxLength="100"
                  />
                  {isLicenseSpecialChar && <div className="error-msg">special characters are not allowed</div>}
              </div>
              <div className="upper">
                  <span>Vehicle Make</span>
                  <input
                    className="pay-fields" 
                    value={item.vehicle_make}
                    name="vehicle_make"
                    onChange={(e) => this.handleAlternateVehicleChange(e, parentIndex, childIndex)}
                    maxLength="100"
                  />
              </div>
              <div className="upper">
                <span>Vehicle Color</span>
                <input
                  className="pay-fields" 
                  value={item["vehicle_color"]}
                  name="vehicle_color"
                  onChange={(e) => this.handleAlternateVehicleChange(e, parentIndex, childIndex)}
                  maxLength={150}
                />
              </div>
            </div>  
          )
        })
      }
    
      handleSpotIncrement(index) {
        const arr = [...this.state.vehicleDetail];
        arr[index]['alternate_vehicles'].push({vehicle_no: '', vehicle_make: '', vehicle_color: ''});
        this.setState({
          vehicleDetail: arr
        })
      }
    
      handleSpotDecrement(index) {
        const arr = [...this.state.vehicleDetail];
        if(arr[index]['alternate_vehicles'] && arr[index]['alternate_vehicles'].length >= 0) {
          arr[index]['alternate_vehicles'] = arr[index]['alternate_vehicles'].slice(0, -1);
          console.log("arr", arr[index]['alternate_vehicles']);
          this.setState({
            vehicleDetail: arr
          })}
      }
    
      getMonthlyPrice(){
        return this.state.monthlyAccountPrice ? '$' + this.state.monthlyAccountPrice : this.props.selectedPass && this.props.selectedPass.pricing_data ? '$' + this.props.selectedPass.pricing_data.rental_fee/100 : '';
      }
    
      getVehicleDetail(){
        const isFillByAccount = this.state.fields.info_filled_by === 'account';
        return this.state.vehicleDetail.map((item, index) => {
          const isLicenseSpecialChar = item.vehicle_no && this.nonSpecialCharacterForValue(item.vehicle_no); 
          const wrap = (<div id="vehicle-detail-wrap">
                          <div className='vehicle-detail'>Member {index + 1}</div>
                          {isFillByAccount && <>
                            <div className="upper">
                                <span>First Name</span>
                                <input
                                  className="pay-fields" 
                                  value={item.first_name}
                                  name="first_name"
                                  onChange={(e) => this.handleVehicleChange(e, index)}
                                  maxLength="100"
                                />
                            </div>
                            <div className="upper">
                                <span>Last Name</span>
                                <input
                                  className="pay-fields" 
                                  value={item.last_name}
                                  name="last_name"
                                  onChange={(e) => this.handleVehicleChange(e, index)}
                                  maxLength="100"
                                />
                            </div>
                            <div className="upper">
                                <span>License Plate {isFillByAccount && <i>*</i>}</span>
                                <input
                                  style={{textTransform: 'uppercase'}}
                                  className="pay-fields" 
                                  value={item.vehicle_no}
                                  name="vehicle_no"
                                  onChange={(e) => this.handleVehicleChange(e, index)}
                                  maxLength="100"
                                />
                                {isFillByAccount && !isLicenseSpecialChar && this.state.errors["vehicle_detail"] && !item.vehicle_no && <div className="error-msg">enter the member's vehicle number</div>}
                                {isLicenseSpecialChar && <div className="error-msg">special characters are not allowed</div>}
                            </div>
                            <div className="upper">
                                <span>Vehicle Make</span>
                                <input
                                  className="pay-fields" 
                                  value={item.vehicle_make}
                                  name="vehicle_make"
                                  onChange={(e) => this.handleVehicleChange(e, index)}
                                  maxLength="100"
                                />
                            </div>
                            {<div className="upper">
                              <span>Vehicle Color</span>
                              <input
                                className="pay-fields" 
                                value={item["vehicle_color"]}
                                name="vehicle_color"
                                onChange={(e) => this.handleVehicleChange(e, index)}
                                maxLength={150}
                              />
                            </div>}
                          </>}
                          <div className="upper">
                            <span>Mobile {!isFillByAccount ? <i>*</i> : ''}</span>
                            <div className="country-with-phone">
                              <div className="country-code">
                                  <ReactCustomFlagSelect
                                    showSearch={false} 
                                    showArrow={true} 
                                    animate={true} 
                                    value={item['country_code']}
                                    customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }}
                                    optionList={staticData.countryCode} 
                                    onChange={areaCode => {
                                      this.handleVehiclePluginChange(index, 'country_code', areaCode);
                                    }}
                                  />
                              </div>
                              <div className="input-wrapper">
                                  <input
                                    className="pay-fields mobile-input" 
                                    value={item["contact_number"]}
                                    name="contact_number"
                                    onChange={(e) => this.handleVehicleChange(e, index)}
                                    maxLength={15}
                                    type='number'
                                  />
                              </div>
                              <div style={{clear: 'both'}}></div>
                            </div>
                            {!isFillByAccount && this.state.errors["vehicle_detail"] && !item.phone && <div className="error-msg">enter the member's mobile number</div>}
                          </div>
                          <div className="upper">
                              <span>Email {!isFillByAccount ? <i>*</i> : ''}</span>
                              <input
                                className="pay-fields" 
                                value={item.email}
                                name="email"
                                onChange={(e) => this.handleVehicleChange(e, index)}
                                maxLength="300"
                              />
                              {!isFillByAccount && this.state.errors["vehicle_detail"] && !item.vehicle_make && <div className="error-msg">enter the member's email</div>}
                          </div>
                          {this.props.isEnforcement && isFillByAccount && <>
                            <div className="upper">
                              <span>Alternate &nbsp;&nbsp;&nbsp; Vehicles</span>
                              <div className='no-of-spot alternate-vehicle-counter'>
                                <img style={{right: '-4px'}} className='add-delete-icon' onClick={() => this.handleSpotIncrement(index)} src={plusIcon} />  
                                <input className='jumbotron__window' type="number" value={this.state.vehicleDetail[index]?.alternate_vehicles?.length} min='0'/>
                                <img className='add-delete-icon' onClick={() => this.handleSpotDecrement(index)} src={minusIcon} /> 
                              </div>
                              <div className="error-msg">{this.state.errors['no_of_spots']}</div>
                            </div>
                            {this.getAlternateVehicleFields(index)}
                          </>}
                        </div>);
          return wrap;
        })                  
      }
    
      
      nonSpecialCharacter(name){
        let fields = this.state.fields;
        return !/[!@#$%^&*()\-_=+\[\]{}|;:'",<.>/?]/g.test(fields[name]);
      }
    
      nonSpecialCharacterForValue(value){
       return /[!@#$%^&*()\-_=+\[\]{}|;:'",<.>/?]/g.test(value);
      }
    
      onlyZip(name){
        let fields = this.state.fields;
        if(!fields[name].match(/^[0-9]{5}$/)){
          return false;
        }
        return true;
      }
    
      onlyPhone(name){
        let fields = this.state.fields;
        if(!fields[name].match(/^[0-9]*$/)){
          return false;
        }
        return true;
      }
    
      onlyEmail(name){
        let fields = this.state.fields;
        if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(fields[name])){
          return false;
        }
        return true;
      }
    
      onlyUserEmail(value){
        if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(value)){
          return false;
        }
        return true;
      }
    
      validateForm(){
        let fields = this.state.fields;
        let formIsValid = true;
        this.errors = {};
        const cardWrapper = document.querySelector('#card-element');
        const cardWrapperError = document.querySelector('#card-errors');
    
        if (!fields["first_name"] || (fields["first_name"] && fields["first_name"].trim() === '')) {
          formIsValid = false;
          this.errors["first_name"] = "enter your first name";
        }
        if (!fields["last_name"] || (fields["last_name"] && fields["last_name"].trim() === '')) {
          formIsValid = false;
          this.errors["last_name"] = "enter your last name";
        }
        if (!fields["phone1"] || (fields["phone1"] && fields["phone1"].trim() === '')) {
          formIsValid = false;
          this.errors["phone1"] = "enter your mobile number";
        }
        if (typeof fields["phone1"] !== "undefined") {
          const isValid = this.onlyPhone("phone1");
          if (!isValid) {
            formIsValid = false;
            this.errors["phone1"] = "enter a valid mobile number";
          }
        }
        if (!fields["email"] || (fields["email"] && fields["email"].trim() === '')) {
          formIsValid = false;
          this.errors["email"] = "enter the admin email address";
        }
        if (fields["email"] != '' && fields["email"].trim() != '') {
          const isValid = this.onlyEmail("email");
          if (!isValid) {
            formIsValid = false;
            this.errors["email"] = "enter a valid admin email address";
          }
        }
        if (this.props.lotType === 'condo' && (!fields["unit_number"] || (fields["unit_number"] && fields["unit_number"].trim() === ''))) {
          formIsValid = false;
          this.errors["unit_number"] = "enter your unit number";
        }
        if (!this.state.validity || !this.state.validity.month && !this.state.validity.year) {
          formIsValid = false;
          this.errors["validity"] = "select the time period";
        } 
        if(this.state.isPayment || this.state.isShowSuite){
          if (!fields["suite"] || (fields["suite"] && fields["suite"].trim() === '')) {
            formIsValid = false;
            this.errors["suite"] = "enter your suite/apt name";
          }
        }
    
        if(this.state.isPayment){
          if (!fields["street_address"] || (fields["street_address"] && fields["street_address"].trim() === '')) {
            formIsValid = false;
            this.errors["street_address"] = "enter your street address";
          }
          if (!fields["city"] || (fields["city"] && fields["city"].trim() === '')) {
            formIsValid = false;
            this.errors["city"] = "enter your city";
          }
          if (!fields["state"] || (fields["state"] && fields["state"].trim() === '')) {
            formIsValid = false;
            this.errors["state"] = "enter your state";
          }
          if (!fields["zip"] || (fields["zip"] && fields["zip"].trim() === '')) {
            formIsValid = false;
            this.errors["zip"] = "enter your zip";
          }
          if(cardWrapper.classList.contains('StripeElement--empty')){
            formIsValid = false;
            cardWrapperError.innerHTML = "enter your card number";
          }
          if(cardWrapper.classList.contains('StripeElement--invalid')){
            formIsValid = false;
            if(!cardWrapperError.innerHTML.trim()) cardWrapperError.innerHTML = "enter valid details";
          }
          if ((!fields["cardholder_name"] || (fields["cardholder_name"] && fields["cardholder_name"].trim() === ''))) {
            formIsValid = false;
            this.errors["cardholder_name"] = "enter the cardholder name";
          }
        }
    
          if (!fields["payment_by"] || (fields["payment_by"] && fields["payment_by"].trim() === '')) {
            formIsValid = false;
            this.errors["payment_by"] = "select the payment by";
          }
          if (!fields["company_name"] || (fields["company_name"] && fields["company_name"].trim() === '')) {
            formIsValid = false;
            this.errors["company_name"] = "enter the company name";
          }
          if (!fields["info_filled_by"] || (fields["info_filled_by"] && fields["info_filled_by"].trim() === '')) {
            formIsValid = false;
            this.errors["info_filled_by"] = "select the information filled by";
          }
          /* for(let i=0; i<this.state.no_of_spots; i++){
            if (!document.querySelector(`input[name=email_${i+1}]`) || (document.querySelector(`input[name=email_${i+1}]`) && document.querySelector(`input[name=email_${i+1}]`).value.trim() === '')) {
              formIsValid = false;
              this.errors["email_"+(i+1)] = "enter user email address";
            }
            if (document.querySelector(`input[name=email_${i+1}]`) != '' && document.querySelector(`input[name=email_${i+1}]`).value.trim() != '') {
              const isValid = this.onlyUserEmail(document.querySelector(`input[name=email_${i+1}]`).value);
              if (!isValid) {
                formIsValid = false;
                this.errors["email_"+(i+1)] = "enter a valid user email address";
              }
            }
          } */
          let arrOfVD = this.state.vehicleDetail;
          const isFillByAccount = this.state.fields.info_filled_by === 'account';
          for (var i = 0; i < arrOfVD.length; i++) {
            let isVehicleFieldEmpty = isFillByAccount ? !arrOfVD[i].vehicle_no : (!arrOfVD[i].email || !arrOfVD[i].contact_number);
            let isLicenseSpecialChar = false;
            if(isFillByAccount){
              isLicenseSpecialChar = arrOfVD[i].vehicle_no && this.nonSpecialCharacterForValue(arrOfVD[i].vehicle_no)
            }
            if (isLicenseSpecialChar) {
              formIsValid = false;
              this.errors["vehicle_detail_license_char_err"] = true;
              break;
            }
            if (isVehicleFieldEmpty) {
              formIsValid = false;
              this.errors["vehicle_detail"] = "incomplete";
              break;
            }
          }

          if(isFillByAccount){
            for (var i = 0; i < arrOfVD.length; i++) {
              if(arrOfVD[i].alternate_vehicles && arrOfVD[i].alternate_vehicles.length){
                let isLicenseSpecialChar = arrOfVD[i].alternate_vehicles.some(obj => 'vehicle_no' in obj && this.nonSpecialCharacterForValue(obj.vehicle_no));
                if (isLicenseSpecialChar) {
                  formIsValid = false;
                  this.errors["vehicle_detail_license_char_err"] = true;
                  break;
                }
              }
            }
          }

          if(this.props.terms && !this.state.isAcceptTC){
            formIsValid = false;
            this.errors["t_and_c"] = "please accept terms & conditions";
          }
    
        this.setState({
          errors: this.errors
        });
        return formIsValid;
      }

      convertValidity(item){
        let start, end;
        let year = item.year;
        let month = item.month;
        month = month < 10 ? '0' + month : month;
        start = `${year}-${month}-01 00:00:00`;
        let lastDay = moment([year, item.month - 1]).endOf('month').format('DD'); 
        end = `${year}-${month}-${lastDay} 23:59:59`;
        return {start, end};
      }

      trimLicensePlate = (arr) => {
        let arrCopy = JSON.parse(JSON.stringify(arr));
        arrCopy.forEach(obj => {
          for (const key in obj) {
            if (key == 'vehicle_no' && obj[key]) {
                obj[key] = obj[key].replace(/\s/g, "").replace(/\\/g, "");
            } 
            if (key == 'alternate_vehicles' && obj[key]?.length) {
              obj[key] = obj[key].map(item => ({...item, vehicle_no: item.vehicle_no?.replace(/\s/g, "").replace(/\\/g, "").toUpperCase()}));
            }
          }
        })
        return arrCopy;
      }

      removeEmptyObjects = data => {
        return data.map(item => {
          const updatedItem = { ...item };
          updatedItem.alternate_vehicles = updatedItem.alternate_vehicles.filter(av => av.vehicle_no || av.vehicle_make || av.vehicle_color);
          return updatedItem;
        });
      }
    
      handlePreSubmit(e){
        if(e) e.preventDefault();
        const isValid = this.validateForm();
        if(!isValid) return;
        /* const isUserEmailValid = this.checkForUserEmails();
        if(!isUserEmailValid) return; */
        const validity = this.convertValidity(this.state.validity);
        let { fields } = this.state;
        const isFillByAccount = this.state.fields.info_filled_by === 'account';
        let vehicleDetail = [];
        if(isFillByAccount){
          vehicleDetail = [...this.state.vehicleDetail];
          vehicleDetail = vehicleDetail.map((item, idx) => {
            return {
              ...item,
              ...{
                country_code: item.country_code ? '+' + item.country_code : '+' + fields.areaCode,
                contact_number: item.contact_number ? item.contact_number : fields.phone1,
                vehicle_no: item.vehicle_no ? item.vehicle_no : `${fields.company_name}${idx + 1}`,
                email: item.email ? item.email : fields.email
              }
            }
          })
        }else{
          vehicleDetail = [...this.state.vehicleDetail];
          vehicleDetail = vehicleDetail.map(item => {
            return {
              ...item,
              ...{
                country_code: '+' + item.country_code
              }
            }
          })
        }
        vehicleDetail = vehicleDetail?.length ? this.trimLicensePlate(vehicleDetail) : [];
        vehicleDetail = this.removeEmptyObjects(vehicleDetail);
        let request = {
            parking_id: this.props.parkingId ? parseInt(this.props.parkingId) : '', 
            first_name: fields.first_name,
            last_name: fields.last_name,
            country_code: '+' + fields.areaCode,
            contact_number: fields.phone1,
            email: fields.email,
            validity_start_time: validity ? validity.start : '',
            validity_end_time: '2030-12-31 23:59:59',
            pass_type: this.props.selectedPass ? this.props.selectedPass.pricing_type : '',
            payment_type: fields.payment_by ? fields.payment_by : 'individual',
            users_info: vehicleDetail,
            spot_count: this.state.no_of_spots ? parseInt(this.state.no_of_spots) : '',
            type: this.props.subscriptionType,
            information_filled_by: fields.info_filled_by,
            company_name: fields.company_name,
            reserve_spot: fields.reserve_spot && this.props.selectedPass && this.props.selectedPass.pricing_data && this.props.selectedPass.pricing_data.is_reserve_spot ? JSON.parse(fields.reserve_spot) : false,
            door_number: fields.suite,
            unit_number: fields.unit_number
        }
        if(this.props.isPayment){
            request = {
              ...request,
              street_address: fields.street_address,
              city: fields.city,
              state: fields.state,
              zip: fields.zip,
              cardholder_name: fields.cardholder_name ? fields.cardholder_name : '',
              unit_number: fields.unit_number
            }
        }
        this.state.isPayment ? this.props.handlePayment() : this.props.handleSubmit(null, null, null, request);
      }

  render() {
    const pickerLang = {
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        from: 'From', to: 'To',
    }

    const makeText = m => {
        if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year)
        return '?'
    }  
    let { fields } = this.state; 
    const vehicleCount = this.state.vehicleDetail ? this.state.vehicleDetail.length : 1;
    const totalAmt = fields.reserve_spot == 'true' ? vehicleCount * ((this.state.convFee + this.state.reservedSpot)/100) : vehicleCount * ((this.state.convFee + this.state.rentalFee)/100); 
    
    return (
        <div className='monthly-consumer'>
          <form onSubmit={this.handlePreSubmit.bind(this)} className="individual" style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto', visibility: this.state.booked ? 'hidden' : 'visible'}} action="#" method="POST">
            <input type="hidden" name="token" />
            <p style={{textAlign:'center', marginBottom: '5px', color: '#333'}}><b>Type - Account</b></p>
            <p style={{color: '#666565', fontSize: '15px', textAlign: 'center', borderBottom: '1px solid #666565', paddingBottom: '10px'}}>Plan Selected: {this.props.selectedPass ? this.props.selectedPass.pricing_type : '' } <span style={{fontSize: '12px'}}>({this.getMonthlyPrice()})</span></p>
            <p style={{color: '#666565', marginTop: '10px'}}>Please enter the following info as part of your registration.</p>
            <p style={{color: '#666565', marginTop: '10px'}}>Location: {this.state.name}</p>
            <span style={{cursor: 'pointer'}} onClick={this.props.changePass.bind(this)} className='close-detail'>
              <img src={closeIcon} />
            </span>
            <div className="upper">
                <span>First Name <i>*</i></span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["first_name"]}
                  name="first_name"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['first_name']}</div>
            </div>
            <div className="upper">
                <span>Last Name <i>*</i> </span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["last_name"]}
                  name="last_name"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['last_name']}</div>
            </div>
            <div className="upper">
              <span>Mobile <i>*</i></span>
              <div className="country-with-phone">
                <div className="country-code">
                    <ReactCustomFlagSelect
                      showSearch={false} 
                      showArrow={true} 
                      animate={true} 
                      value={this.state.fields['areaCode']}
                      customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }}
                      optionList={staticData.countryCode} 
                      onChange={areaCode => {
                        this.handleAreaCode(areaCode);
                      }}
                    />
                </div>
                <div className="input-wrapper">
                    <input
                      className="pay-fields mobile-input" 
                      value={this.state.fields["phone1"]}
                      name="phone1"
                      onChange={this.handleChange}
                      maxLength={15}
                      type='number'
                    />
                </div>
                <div style={{clear: 'both'}}></div>
              </div>
              <div className="error-msg">{this.state.errors['phone1']}</div>
            </div>
            {this.props.subscriptionType === 'account' && <div className="upper">
                <span>Company Name <i>*</i> </span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["company_name"]}
                  name="company_name"
                  onChange={this.handleChange}
                  maxLength={200}
                />
                <div className="error-msg">{this.state.errors['company_name']}</div>
            </div>}
            <div className="upper">
              <span>{this.props.subscriptionType === 'account' ? 'Admin Email' : 'Email'} <i>*</i></span>
              <input
                className="pay-fields" 
                value={this.state.fields["email"]}
                name="email"
                onChange={this.handleChange}
                maxLength={250}
              />
              <div className="error-msg">{this.state.errors['email']}</div>
            </div>
            {this.props.lotType === "condo" && <div className="upper">
              <span>Unit No.<i>*</i></span>
              <input
                className="pay-fields" 
                value={this.state.fields["unit_number"]}
                name="unit_number"
                onChange={this.handleChange}
                maxLength={250}
              />
              <div className="error-msg">{this.state.errors['unit_number']}</div>
            </div>}
            {(this.state.isPayment || this.state.isShowSuite) && <div className="upper">
              <span onClick={() => this.handleFocus('suite')}>Apt. Suite <i>*</i></span>
              <input
                className="pay-fields" 
                value={this.state.fields["suite"]}
                name="suite"
                onChange={this.handleChange}
                maxLength={150}
              />
              <div className="error-msg">{this.state.errors['suite']}</div>
            </div>}
            {this.state.isPayment && <div>
              <div className="upper">
                <span onClick={() => this.handleFocus('street_address')}>Street Address <i>*</i></span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["street_address"]}
                  name="street_address"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['street_address']}</div>
              </div>
              <div className="upper">
                  <span onClick={() => this.handleFocus('city')}>City <i>*</i></span>
                  <input
                    className="pay-fields" 
                    value={this.state.fields["city"]}
                    name="city"
                    onChange={this.handleChange}
                    maxLength={150}
                  />
                  <div className="error-msg">{this.state.errors['city']}</div>
              </div>
              <div className="upper">
                <span onClick={() => this.handleFocus('state')}>State <i>*</i></span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["state"]}
                  name="state"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['state']}</div>
              </div>
              <div className="upper">
                <span onClick={() => this.handleFocus('zip')}>Zip <i>*</i></span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["zip"]}
                  name="zip"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['zip']}</div>
              </div>
            </div>}
            <div className="upper monthly-parking-filter">
              <span>Starting Month <i>*</i></span>
              {!this.state.resetMonthPicker && <Picker
                  ref={this.pickMulti}
                  years={{min: this.monthPickerLimitMin, max: this.monthPickerLimitMax}}
                  value={this.state.validity}
                  lang={pickerLang.months}
                  theme="light"
                  onChange={this.handleValidityChange}
              >
                  <MonthBox value={this.state.validity ? makeText(this.state.validity) : ''} onClick={this.handleClickValidity} />
              </Picker>}
              <div className="error-msg">{this.state.errors['validity']}</div>
            </div>
            {this.props.subscriptionType === 'account' && <div className="upper">
              <span>Payment By <i>*</i></span>
              <select
                className="pay-fields car-type" 
                value={this.state.fields["payment_by"]}
                name="payment_by"
                onChange={this.handleChange}
                maxLength={150}
                disabled={true}
              >
                  <option value=''>Choose</option>
                  <option value="account">Account</option>
                  <option value="individual">Individual</option>
              </select>
              <div className="error-msg">{this.state.errors['payment_by']}</div>
            </div>}
            {this.props.subscriptionType === 'account' && <div className="upper">
              <span>Info. Filled By <i>*</i></span>
              <select
                className="pay-fields car-type" 
                value={this.state.fields["info_filled_by"]}
                name="info_filled_by"
                onChange={this.handleChange}
                maxLength={150}
                disabled={true}
              >
                  <option value=''>Choose</option>
                  <option value="account">Account</option>
                  <option value="individual">Individual</option>
              </select>
              <div className="error-msg">{this.state.errors['info_filled_by']}</div>
            </div>}
            {this.state.selectedPass && this.state.selectedPass.pricing_data && this.state.selectedPass.pricing_data.is_reserve_spot && <div className="upper">
              <span>Reserve Spot</span>
              <select
                className="pay-fields car-type" 
                value={this.state.fields["reserve_spot"]}
                name="reserve_spot"
                onChange={this.handleChange}
                maxLength={150}
              >
                <option value=''>Choose</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
            </select>
              <div className="error-msg">{this.state.errors['reserve_spot']}</div>
            </div>}
            {this.state.fields.info_filled_by && <div className="upper">
              <span>No. Of Members <i>*</i></span>
              <div className='no-of-spot'>
                <img style={{right: '-4px'}} className='add-delete-icon' onClick={this.handleVehicleIncrement.bind(this)} src={plusIcon} />  
                <input className='jumbotron__window' type="number" value={this.state.no_of_vehicles} min='1'/>
                <img className='add-delete-icon' onClick={this.handleVehicleDecrement.bind(this)} src={minusIcon} /> 
              </div>
              <div className="error-msg">{this.state.errors['no_of_vehicles']}</div>
            </div>}
            <div>
              {this.state.fields.info_filled_by && this.getVehicleDetail()}
            </div>
            {this.state.isPayment && <div>
              <h3 style={{paddingTop: 20, fontSize: '16.5px'}}>Payment Amount: {totalAmt > -1 ? `$${totalAmt}/per month` : ''}</h3>
              <h5 style={{padding: "15px 0"}}>Card Information</h5>
              <div className="card-info">
                <div id="card-element">
                </div>
              </div>
              <div className="error-msg" id="card-errors" role="alert"></div>
              <div class="group">
                <label>
                <input onChange={this.handleChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder name" />
                </label>
              </div>
              <div style={{padding: '6px 0 0 14px'}} className="error-msg">{this.state.errors['cardholder_name']}</div>
            </div>}  
            {this.props.terms && <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                onClick={this.handleAcceptTC.bind(this)}
                checked={this.state.isAcceptTC}
                id="register-checkbox"
                type="checkbox"
              />
              <label htmlFor="register-checkbox" style={{ marginLeft: 8, fontWeight: 400 }}>
                I agree to the {' '}
                <span
                  style={{ color: 'rgb(220, 110, 125)', cursor: 'pointer' }}
                  onClick={(e) => {
                    e.preventDefault(); 
                    this.props.onOpenModal(); 
                  }}
                >&nbsp;terms and conditions</span>
              </label>
            </div>}
            <div style={{textAlign: 'left'}} className="error-msg">{this.state.errors['t_and_c']}</div>
            <button style={{width: this.state.isPayment ? '100%' : '150px'}} id="pay-submit" type="submit">{this.state.fields?.payment_by === "individual" || !this.props.isAutoApproval ? 'Save' : 'Next'}</button>
            <div style={{clear: 'both'}} />
          </form>
        </div>
    )
  }
}

class MonthBox extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            value: this.props.value || 'N/A',
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            value: props.value || 'N/A',
        }
    }

    render() {

        return (
            <div className="box" onClick={this._handleClick}>
                <label>{this.state.value}</label>
            </div>
        )
    }

    _handleClick = (e) => {
        this.props.onClick && this.props.onClick(e)
    }
}
